import { render } from "./VideoOverlay.vue?vue&type=template&id=7a8d1027&scoped=true"
import script from "./VideoOverlay.vue?vue&type=script&lang=js"
export * from "./VideoOverlay.vue?vue&type=script&lang=js"

import "./VideoOverlay.vue?vue&type=style&index=0&id=7a8d1027&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8d1027"]])

export default __exports__